import { defineStore } from 'pinia';
import { NotificationObj, NotificationState } from '@cnamts/vue-dot/src/modules/notification/types';

export const useNotificationStore = defineStore({
  id: 'notification',
  state: (): NotificationState => ({
	notification: null
  }),

  actions: {
	add(notification: NotificationObj) {
		this.notification = notification;
	},
	clearNotification() {
		this.notification = null;
	}
  },
  persist: true
});
